import { defineMessages } from "react-intl";

import {
	igGMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/viral-serology/varicella";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	varicella: {
		id: "ktx.varicella.title",
		defaultMessage: "Varicella"
	},
	igg: {
		id: "ktx.varicella.field.igg",
		defaultMessage: "IgG"
	},
	igm: {
		id: "ktx.varicella.field.igm",
		defaultMessage: "IgM"
	}
});

const fields: { [key: string]: FieldData } = {
	igG: {
		type: "field",
		path: ["igG"],
		label: messages.igg,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: igGMessages } }
	},
	igM: {
		type: "field",
		path: ["igM"],
		label: messages.igm,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: igGMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.igG }] },
		{ columns: [{ width: 12, field: fields.igM }] }
	]
};

export const node: LeafNode = {
	id: "ktx_varicella",
	value: {
		schemaId: "varicella",
		title: messages.varicella,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
